<template>
    <div>
        <div class="h-100 tw-border-l tw-border-grey-light tw-bg-white tw-rounded tw-overflow-y-auto tw-py-10">
            <div class="tw-text-center">
                <div class="tw-bg-grey-light tw-h-24 tw-m-auto tw-rounded-full tw-text-5xl tw-text-grey-dark tw-w-10
                    tw-w-24 tw-mb-4" style="line-height: 93px;">
                    {{ chatActive.initials }}
                </div>
                <div class="tw-mb-3 tw-text-xl">
                    {{ chatActive.contact.name }}
                </div>
                <div>
                    <a v-if="chatActive.contact.phone_number"
                        class="btn btn-outline-primary tw-rounded-full"
                        :href="`tel:${chatActive.contact.phone_number}`">
                        <i class="fa fa-phone"></i> Call
                    </a>
                    <a v-if="chatActive.contact.email"
                        class="btn btn-outline-primary tw-rounded-full tw-ml-3"
                        :href="`mailto:${chatActive.contact.email}`">
                        <i class="fa fa-envelope"></i> Email
                    </a>
                </div>
            </div>
            <div class="tw-px-6 tw-my-6">
                <div>
                    <span class="tw-font-extrabold tw-mt-6 tw-text-grey-darker">Groups: </span>
                    <span v-for="(group, index) in chatActive.contact.groups" :key="`group-${index}`">
                        {{ index > 0 ? ',' : '' }} {{ group.name }}
                    </span>
                </div>
                <div class="tw-mt-2">
                    <span class="tw-font-extrabold tw-mt-6 tw-text-grey-darker">Locations: </span>
                    <span v-for="(location, index) in chatActive.contact.locations"
                        :key="`location-${index}`">
                        {{ index > 0 ? ',' : '' }} {{ location.name }}
                    </span>
                </div>
                <div class="tw-mt-2">
                    <span class="tw-font-extrabold tw-mt-6 tw-text-grey-darker">WebChat Groups: </span>
                    <span v-for="(webChatGroup, index) in chatActive.contact.webChatGroups"
                          :key="`location-${index}`">
                        {{ index > 0 ? ',' : '' }} {{ webChatGroup.name }}
                    </span>
                </div>
            </div>
            <hr>
            <div class="tw-px-6">
                <div class="tw-font-extrabold tw-mb-3 tw-mt-6 tw-text-grey-darker">
                    Reviews
                </div>
                <div v-for="review in chatActive.contact.reviews" :key="review.id">
                    <div class="tw-flex tw-mb-2 tw-justify-between">
                        <div class="tw-flex tw-justify-between">
                            <review-icon :icon="review.origin" class="tw-mr-4"/>
                            <rating-stars
                                :stars="5"
                                :disabled="true"
                                :value="review.rating"
                                style="font-size: 1rem;"
                            />
                        </div>
                        <div class="tw-pt-2 tw-text-grey-dark tw-text-sm">
                            {{ review.review_date | humanize }}
                        </div>
                    </div>
                    <div v-if="review.body" class="tw-text-grey-dark tw-text-sm tw-pl-1">
                        {{ review.body }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            chatActive: {
                type: Object,
                required: true
            }
        },

        filters: {
            humanize(value) {
                if (_.isObject(value)) {
                    return moment
                        .tz(value.date, 'UTC')
                        .tz(moment.tz.guess())
                        .fromNow();
                }

                if (moment(value).isValid()) {
                    return moment
                        .tz(value, 'UTC')
                        .tz(moment.tz.guess())
                        .fromNow();
                }

                return value;
            }
        }
    };
</script>
